<template>
    <!-- Chưa đăng nhập -->
    <RouterLink v-if="!isLogin" to="/login" class="nav-item text-white text-uppercase">
        ĐĂNG NHẬP
    </RouterLink>

    <!-- Đã đăng nhập - khách hàng -->
    <MainMenu v-else-if="role === 'ROLE_CUSTOMER'" :isMobile="isMobile" />

    <!-- Đã đăng nhập - nhân viên / admin -->
    <StaffMenu v-else-if="isStaff" :isMobile="isMobile" />
</template>

<script setup>
    import { computed } from 'vue'
    import { authRole } from '@/utils/authState'
    import MainMenu from '@/components/common/menus/MainDropdownMenu.vue'
    import StaffMenu from '@/components/common/menus/StaffDropdownMenu.vue'

    defineProps({
        isMobile: {
            type: Boolean,
            default: false
        }
    })

    const role = computed(() => authRole.value)

    const isLogin = computed(() => authRole.value !== null)

    const isStaff = computed(() =>
        authRole.value === 'ROLE_ADMIN' ||
        authRole.value === 'ROLE_EMPLOYER'
    )
</script>